import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Shield } from 'lucide-react';
export function NoGuarantee() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-5 sm:px-6 bg-gradient-to-b from-black via-stone-950 to-black overflow-hidden" data-id="element-2048" data-mp="2uir1dexalaqo">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 50
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-2049" data-mp="3n4sfhbz2bmmj">
        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-2050" data-mp="3deh81fg66vaw">
          <motion.div className="w-24 h-px bg-gradient-to-r from-transparent via-yellow-500/50 to-yellow-500/50" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%'
        }} data-id="element-2051" data-mp="3ieby5gs4fguw" />
          <motion.div animate={{
          rotate: [0, 360],
          scale: [1, 1.15, 1]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-2052" data-mp="1t484y1vuumde">
            <Shield className="w-10 h-10 text-yellow-400" style={{
            filter: 'drop-shadow(0 0 20px rgba(250, 204, 21, 0.8))'
          }} data-id="element-2053" data-mp="22vunkjaivnq6" />
          </motion.div>
          <motion.div className="w-24 h-px bg-gradient-to-l from-transparent via-yellow-500/50 to-yellow-500/50" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%'
        }} data-id="element-2054" data-mp="2bt4xo1blt6ti" />
        </div>

        <motion.h2 className="text-3xl sm:text-4xl md:text-5xl font-serif mb-10 sm:mb-12 text-center" style={{
        fontFamily: 'Cinzel, serif'
      }} animate={{
        textShadow: ['0 0 40px rgba(250, 204, 21, 0.6)', '0 0 60px rgba(250, 204, 21, 0.9)', '0 0 40px rgba(250, 204, 21, 0.6)']
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-2055" data-mp="re33knxp7vb5">
          <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-200 bg-clip-text text-transparent" style={{
          backgroundSize: '200% 100%',
          filter: 'drop-shadow(0 0 30px rgba(250, 204, 21, 0.8))'
        }} data-id="element-2056" data-mp="1l42djbzfvjgn">
            The Guarantee
          </span>
        </motion.h2>

        <div className="space-y-6 text-lg leading-relaxed" data-id="element-2057" data-mp="1z31r9oleydy1">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={inView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative p-6 sm:p-8 md:p-10 border-2 sm:border-4 border-yellow-500 bg-gradient-to-br from-yellow-950/40 via-yellow-900/30 to-black overflow-hidden shadow-[0_0_16px_rgba(250,204,21,0.26),inset_0_0_32px_rgba(250,204,21,0.08)] sm:shadow-[0_0_60px_rgba(250,204,21,0.4),inset_0_0_60px_rgba(250,204,21,0.1)]" data-id="element-2058" data-mp="23uthtz4kkjo6">
            <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-400/20 to-transparent" animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-2059" data-mp="24url4wjqglm" />

            <div className="absolute top-0 left-0 w-8 h-8 sm:w-12 sm:h-12 border-l-2 border-t-2 sm:border-l-4 sm:border-t-4 border-yellow-300" data-id="element-2060" data-mp="pu6whskuc2i4" />
            <div className="absolute top-0 right-0 w-8 h-8 sm:w-12 sm:h-12 border-r-2 border-t-2 sm:border-r-4 sm:border-t-4 border-yellow-300" data-id="element-2061" data-mp="kyhtff9m43h2" />
            <div className="absolute bottom-0 left-0 w-8 h-8 sm:w-12 sm:h-12 border-l-2 border-b-2 sm:border-l-4 sm:border-b-4 border-yellow-300" data-id="element-2062" data-mp="b5aqs269b1ko" />
            <div className="absolute bottom-0 right-0 w-8 h-8 sm:w-12 sm:h-12 border-r-2 border-b-2 sm:border-r-4 sm:border-b-4 border-yellow-300" data-id="element-2063" data-mp="18nsukxuvjzvq" />

            <div className="relative" data-id="element-2064" data-mp="obyj8copzl36">
              <p className="text-3xl text-center font-bold text-yellow-100 mb-4" style={{
              textShadow: '0 0 30px rgba(253, 224, 71, 0.6)'
            }} data-id="element-2065" data-mp="of2vlxcc9n4x">
                Once you're in, you're in.
              </p>
              <p className="text-2xl text-center text-yellow-200 font-semibold" data-id="element-2066" data-mp="jdn9e1yfdaky">
                We don't offer refunds.
              </p>
            </div>
          </motion.div>

          <p className="text-2xl text-yellow-300 font-bold text-center" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-2067" data-mp="175u0alldspcz">
            Here's why:
          </p>

          <div className="space-y-4 text-stone-300" data-id="element-2068" data-mp="xblm72x3kyyc">
            <p data-id="element-2069" data-mp="12bzijnpc6kgj">
              If you need a guarantee to feel safe investing, you're not ready
              for this.
            </p>

            <p data-id="element-2070" data-mp="1q10wfqgxunt7">
              This is for people who already know the value Brenden and Ali
              bring.
            </p>

            <p data-id="element-2071" data-mp="3fjhcbdnk8qju">
              Who've read Peptide Salvation and understand the depth of their
              knowledge.
            </p>

            <p data-id="element-2072" data-mp="3ajcthgz6jjqg">Who've seen the testimonials of "impossible" transformations.</p>

            <p data-id="element-2073" data-mp="3p9sgn1b5p1r9">
              Who understand that access to this level of expertise is worth
              exponentially more than the investment.
            </p>

            <p data-id="element-2074" data-mp="3kcaepuvk3msr">
              Who are committed to their own transformation, not looking for an
              escape hatch.
            </p>
          </div>

          <motion.p initial={{
          opacity: 0,
          x: -20
        }} animate={inView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-xl text-yellow-200 font-bold" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-2075" data-mp="2rmjyngad6au0">
            We've found the only people who request refunds are people who
            shouldn't have bought in the first place.
          </motion.p>

          <div className="space-y-3 text-stone-300 ml-4 sm:ml-6" data-id="element-2076" data-mp="39mw8fvjr5o3j">
            <p data-id="element-2077" data-mp="3emsavqcsx7gz">They weren't ready.</p>
            <p data-id="element-2078" data-mp="3elqynik1uexo">They didn't actually value the expertise.</p>
            <p data-id="element-2079" data-mp="3jmeow20gerqu">
              They were looking for a magic pill instead of systematic
              optimization.
            </p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="relative p-5 sm:p-8 border-l-4 border-yellow-500 bg-gradient-to-br from-yellow-950/30 to-black my-8" style={{
          boxShadow: '0 0 30px rgba(250, 204, 21, 0.2)'
        }} data-id="element-2080" data-mp="3nn6y4v9bswn4">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-400 via-yellow-500 to-transparent" data-id="element-2081" data-mp="34q5upevf74la" />

            <p className="text-2xl text-yellow-200 font-bold mb-6" style={{
            textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
          }} data-id="element-2082" data-mp="2c8jyb6qd4ake">
              Our commitment is to deliver world-class intelligence.
            </p>

            <div className="space-y-4 text-stone-300" data-id="element-2083" data-mp="1zr0td1s7z997">
              <p className="flex items-start gap-3" data-id="element-2084" data-mp="1vocjcqrrrwan">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2085" data-mp="1vn1esoqi2kih">•</span>
                <span data-id="element-2086" data-mp="1qpszcvwqkukx">
                  To give you live sessions with two of the most advanced
                  biological optimization experts in the world.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-2087" data-mp="1gz7zz698nm0y">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2088" data-mp="1gxdenqu21rwc">•</span>
                <span data-id="element-2089" data-mp="1c0wqiwmuvdj9">
                  To provide you with the most comprehensive peptide training
                  ever created.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-2090" data-mp="12zylqc4lf1zm">
                <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2091" data-mp="131rvi0ai62bu">•</span>
                <span data-id="element-2092" data-mp="y144vfq6rni5">
                  To share exclusive bonuses, case studies, and reports that
                  save you thousands in wasted purchases.
                </span>
              </p>
            </div>
          </motion.div>

          <p className="text-2xl text-yellow-200 font-bold" style={{
          textShadow: '0 0 20px rgba(253, 224, 71, 0.4)'
        }} data-id="element-2093" data-mp="2cwlx9b0u22ey">
            Your commitment is to show up, absorb, and apply it.
          </p>

          <div className="space-y-3 text-stone-300 ml-4 sm:ml-6" data-id="element-2094" data-mp="236aggnw1vyqn">
            <p className="flex items-start gap-3" data-id="element-2095" data-mp="234pon614etwh">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2096" data-mp="27ykdenvl1z2f">•</span>
              <span data-id="element-2097" data-mp="1u6dzl8fwk465">To ask questions during the live sessions.</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-2098" data-mp="1u4b0lywrv0pa">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2099" data-mp="1y8iojtveocmg">•</span>
              <span data-id="element-2100" data-mp="1k7eo7i3r5ufg">To implement the protocols.</span>
            </p>
            <p className="flex items-start gap-3" data-id="element-2101" data-mp="1kaamj7jiil4f">
              <span className="text-yellow-400 text-xl mt-0.5" data-id="element-2102" data-mp="1p5zofhj08e3w">•</span>
              <span data-id="element-2103" data-mp="15kzk5jdbegm5">To optimize based on your results.</span>
            </p>
          </div>

          <motion.div className="h-1 bg-gradient-to-r from-yellow-500 via-yellow-300 to-yellow-500 my-10" animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'linear'
        }} style={{
          backgroundSize: '200% 100%',
          boxShadow: '0 0 20px rgba(250, 204, 21, 0.6)'
        }} data-id="element-2104" data-mp="10meeh4fan4qb" />

          <p className="text-2xl text-stone-100 font-bold text-center" data-id="element-2105" data-mp="1jljzu6nxnwbf">
            If you don't want to commit to this…
          </p>

          <p className="text-xl text-stone-300 text-center" data-id="element-2106" data-mp="1y9dftsgxl0uj">That's okay.</p>

          <p className="text-xl text-stone-300 text-center" data-id="element-2107" data-mp="1tak3w4halhwh">
            This isn't for everyone.
          </p>

          <motion.p className="text-3xl font-bold text-center" style={{
          fontFamily: 'Cinzel, serif'
        }} animate={{
          scale: [1, 1.02, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-2108" data-mp="27beb4jsltctk">
            
          </motion.p>
        </div>
      </motion.div>
    </section>;
}